import React, { useEffect, useState } from 'react';
import { AgGridReact } from 'ag-grid-react';
import { ClientSideRowModelModule } from 'ag-grid-community';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import Papa from 'papaparse';

// Custom cell renderer for Google Maps Link
const GoogleMapLinkCellRenderer = (props) => {
    if (!props.value) {
        return <span>No Link Available</span>;
    }

    return (
      <a href={props.value} target="_blank" rel="noopener noreferrer">
        View on Google Maps
      </a>
    );
  };

  const EntitySiteLinkCellRenderer = (props) => {
    if (!props.value) {
        return <span>No Link Available</span>;
    }
    
    return (
      <a href={props.value} target="_blank" rel="noopener noreferrer">
        View Site
      </a>
    );
  };

  // Custom Cell Renderer that changes background color based
  // on prop value.
  // Y = YES = GREEN
  // N = NO = RED
  // U = UNKNOWN = YELLOW
  const DateOpenCellRenderer = (props) => {
    let backgroundColor = 'white';
    if (props.value === 'In Session') {
      backgroundColor = 'darkseagreen';
    } else if (props.value === 'Not In Session') {
      backgroundColor = 'darksalmon';
    } else if (props.value === 'Unknown') {
      backgroundColor = 'lightgrey';
    }
  
    return (
      <div style={{ backgroundColor }}>
        {props.value}
      </div>
    );
  }

const ActivityTable2026 = () => {
    const [rowData, setRowData] = useState([]);
    const [visibleColumns, setVisibleColumns] = useState({
        june_16_20: true,
        june_23_27: true,
        june_30_04: true,
        july_07_11: true,
        july_14_18: true,
        july_21_25: true,
        july_28_01: true,
        august_04_08: true,
        august_11_15: true,
        august_18_22: true,
        august_25_29: true,
      });

    useEffect(() => {
        Papa.parse('/data/2026.csv', {
          download: true,
          header: true,
          complete: (result) => {
            setRowData(result.data);
          },
        });
      }, []);

      const handleCheckboxChange = (event) => {
        const { name, checked } = event.target;
        setVisibleColumns((prev) => ({
          ...prev,
          [name]: checked,
        }));
      };

      const columnDefs = [
        { headerName: 'Name', field: 'entity_name' },
        { headerName: 'Registration Open', field: 'entity_registration_open' },
        { headerName: 'Registration Open Date', field: 'entity_registration_open_date' },
        { headerName: 'Type', field: 'entity_type' },
        { headerName: 'Locale', field: 'entity_locale' },
        { headerName: 'Min Age', field: 'entity_age_min' },
        { headerName: 'Max Age', field: 'entity_age_max' },
        { headerName: 'Hours', field: 'full_or_partial_day' },
        { 
            headerName: 'Web Site', 
            field: 'entity_web_link',
            cellRenderer: EntitySiteLinkCellRenderer,
        },
        {
            headerName: 'Google Maps Link',
            field: 'entity_google_maps_link',
            cellRenderer: GoogleMapLinkCellRenderer,
        },
        ...(visibleColumns.june_16_20 ? [{
            headerName: 'JUNE 15 - JUNE 19',
            field: 'open_date_june_16_20',
            cellRenderer: DateOpenCellRenderer,
          }] : []),
          ...(visibleColumns.june_23_27 ? [{
            headerName: 'JUNE 22 - JUNE 26',
            field: 'open_date_june_23_27',
            cellRenderer: DateOpenCellRenderer,
          }] : []),
          ...(visibleColumns.june_30_04 ? [{
            headerName: 'JUNE 29 - JULY 03',
            field: 'open_date_june_30_04',
            cellRenderer: DateOpenCellRenderer,
          }] : []),
          ...(visibleColumns.july_07_11 ? [{
            headerName: 'JULY 06 - JULY 10',
            field: 'open_date_july_07_11',
            cellRenderer: DateOpenCellRenderer,
          }] : []),
          ...(visibleColumns.july_14_18 ? [{
            headerName: 'JULY 13 - JULY 17',
            field: 'open_date_july_14_18',
            cellRenderer: DateOpenCellRenderer,
          }] : []),
          ...(visibleColumns.july_21_25 ? [{
            headerName: 'JULY 20 - JULY 24',
            field: 'open_date_july_21_25',
            cellRenderer: DateOpenCellRenderer,
          }] : []),
          ...(visibleColumns.july_28_01 ? [{
            headerName: 'JULY 27 - JULY 31',
            field: 'open_date_july_28_01',
            cellRenderer: DateOpenCellRenderer,
          }] : []),
          ...(visibleColumns.august_04_08 ? [{
            headerName: 'AUGUST 03 - AUGUST 07',
            field: 'open_date_august_04_08',
            cellRenderer: DateOpenCellRenderer,
          }] : []),
          ...(visibleColumns.august_11_15 ? [{
            headerName: 'AUGUST 10 - AUGUST 14',
            field: 'open_date_august_11_15',
            cellRenderer: DateOpenCellRenderer,
          }] : []),
          ...(visibleColumns.august_18_22 ? [{
            headerName: 'AUGUST 17 - AUGUST 21',
            field: 'open_date_august_18_22',
            cellRenderer: DateOpenCellRenderer,
          ...(visibleColumns.august_25_29 ? [{
            headerName: 'AUGUST 24 - AUGUST 28',
            field: 'open_date_august_25_29',
            cellRenderer: DateOpenCellRenderer,
          }] : []),
          }] : []),
      ];

      return (
        <div>
          <h1>2026 Summer Camps</h1>
          <h3>The following information may not be accurate or up to date! It's always best to check with individual camps
            for the most current information. We make no endorsement about the camps listed here.
          </h3>

          <div>
            <h2>2026 Session Weeks</h2>
            <p>
                Check the boxes below to show if each camp is running a session that week. This does not mean the camp has availability, just that they 
                have a session that week.
            </p>
        <label>
          <input
            type="checkbox"
            name="june_16_20"
            checked={visibleColumns.june_16_20}
            onChange={handleCheckboxChange}
          />
          JUNE 15 - JUNE 19
        </label> <br />
        <label>
          <input
            type="checkbox"
            name="june_23_27"
            checked={visibleColumns.june_23_27}
            onChange={handleCheckboxChange}
          />
          JUNE 22 - JUNE 26
        </label> <br />
        <label>
          <input
            type="checkbox"
            name="june_30_04"
            checked={visibleColumns.june_30_04}
            onChange={handleCheckboxChange}
          />
          JUNE 29 - JULY 03
        </label><br />
        <label>
          <input
            type="checkbox"
            name="july_07_11"
            checked={visibleColumns.july_07_11}
            onChange={handleCheckboxChange}
          />
          JULY 06 - JULY 10
        </label><br />
        <label>
          <input
            type="checkbox"
            name="july_14_18"
            checked={visibleColumns.july_14_18}
            onChange={handleCheckboxChange}
          />
          JULY 13 - JULY 17
        </label><br />
        <label>
          <input
            type="checkbox"
            name="july_21_25"
            checked={visibleColumns.july_21_25}
            onChange={handleCheckboxChange}
          />
          JULY 20 - JULY 24
        </label><br />
        <label>
          <input
            type="checkbox"
            name="july_28_01"
            checked={visibleColumns.july_28_01}
            onChange={handleCheckboxChange}
          />
          JULY 27 - JULY 31
        </label><br />
        <label>
          <input
            type="checkbox"
            name="august_04_08"
            checked={visibleColumns.august_04_08}
            onChange={handleCheckboxChange}
          />
          AUGUST 03 - AUGUST 07
        </label><br />
        <label>
          <input
            type="checkbox"
            name="august_11_15"
            checked={visibleColumns.august_11_15}
            onChange={handleCheckboxChange}
          />
          AUGUST 10 - AUGUST 14
        </label><br />
        <label>
          <input
            type="checkbox"
            name="august_18_22"
            checked={visibleColumns.august_18_22}
            onChange={handleCheckboxChange}
          />
          AUGUST 17 - AUGUST 21
        </label><br />
        <label>
          <input
            type="checkbox"
            name="august_25_29"
            checked={visibleColumns.august_25_29}
            onChange={handleCheckboxChange}
          />
          AUGUST 24 - AUGUST 28
        </label><br /><br />
      </div>

          <div className="ag-theme-alpine" style={{ height: 400, width: '100%' }}>
            <AgGridReact
              rowData={rowData}
              columnDefs={columnDefs}
              pagination={true}
              paginationPageSize={10}
              modules={[ClientSideRowModelModule]}
            />
          </div>
        </div>
    );
};

export default ActivityTable2026;
